import template from './visual-divider.jade';

export default angular
    .module('cian.addForm.visualDivider', [])
    .directive('cianAfHelperVisualDivider', () => ({
        template,
    }))
    .name;
